import { MODULES } from '@core/constants/modules.contants';
import { ROUTER } from '@core/constants/router.constants';
import { useService } from '@policoders/di';
import Layout from '@shared/components/layout.component';
import { NavbarItem } from '@shared/components/navbar/navbar-item.model';
import NavbarService from '@shared/components/navbar/navbar.service';
import { Outlet } from 'react-router-dom';

export const ChefsAssistantLayout: React.FC = () => {
  const getPath = (path: string) => `/${ROUTER.CHEFS_ASSISTANT.INDEX}${path ? `/${path}` : ''}`;
  const items: NavbarItem[] = [
    { label: 'Início', to: getPath(''), type: 'nav-item' },
    {
      label: 'Livro caixa',
      to: getPath(ROUTER.CHEFS_ASSISTANT.CASH_BOOK),
      type: 'nav-item',
    },
    {
      label: 'Fichas técnicas',
      to: getPath(ROUTER.CHEFS_ASSISTANT.TECHNICAL_SHEETS),
      type: 'nav-item',
    },
    {
      label: 'Produtos',
      to: getPath(ROUTER.CHEFS_ASSISTANT.STOCK.PRODUCTS),
      type: 'nav-item',
    },
  ];
  const navbar = useService<NavbarService>('NavbarService');
  navbar.set({ module: MODULES.CHEFS_ASSISTANT, navbar: items });
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
};
